import BookmarkIcon from '@mui/icons-material/Bookmark';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { Tab, Tabs } from '@mui/material';

import { useNavigate } from 'react-router-dom';

import { AdminRoomTab } from '@/utils/constants';

export const RoomIndexTab = (props: {
  selected: AdminRoomTab;
  tab1: {
    label: string;
    redirectTo?: string;
  };
  tab2: {
    label: string;
    redirectTo?: string;
  };
  tab3: {
    label: string;
    redirectTo?: string;
  };
  dense?: boolean;
}) => {
  const navigate = useNavigate();

  return (
    <Tabs
      value={false}
      sx={{
        width: 1,
        margin: '0 auto',
        '& .MuiTabs-flexContainer': {
          gap: props.dense ? 0.5 : 2,
        },
        '& .MuiTab-root': {
          flexGrow: 1,
          minHeight: 50,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          maxWidth: 1,
        },
      }}
      TabIndicatorProps={{
        hidden: true,
      }}
    >
      <Tab
        sx={{
          backgroundColor: (t) =>
            props.selected === AdminRoomTab.management
              ? t.palette.common.white
              : t.palette.secondary.main,
          fontSize: props.dense ? '80%' : undefined,
          padding: props.dense ? 0 : undefined,
        }}
        label={props.tab1.label}
        value={AdminRoomTab.management}
        iconPosition="start"
        onClick={() => {
          if (props.tab1.redirectTo != null) navigate(props.tab1.redirectTo);
        }}
      />
      <Tab
        sx={{
          backgroundColor: (t) =>
            props.selected === AdminRoomTab.template
              ? t.palette.common.white
              : t.palette.secondary.main,
          fontSize: props.dense ? '80%' : undefined,
          padding: props.dense ? 0 : undefined,
        }}
        label={props.tab2.label}
        value={AdminRoomTab.template}
        icon={props.dense ? undefined : <MenuBookIcon />}
        iconPosition="start"
        onClick={() => {
          if (props.tab2.redirectTo != null) navigate(props.tab2.redirectTo);
        }}
      />
      <Tab
        sx={{
          backgroundColor: (t) =>
            props.selected === AdminRoomTab.homophone
              ? t.palette.common.white
              : t.palette.secondary.main,
          fontSize: props.dense ? '80%' : undefined,
          padding: props.dense ? 0 : undefined,
        }}
        label={props.tab3.label}
        value={AdminRoomTab.homophone}
        icon={props.dense ? undefined : <BookmarkIcon />}
        iconPosition="start"
        onClick={() => {
          if (props.tab3.redirectTo != null) navigate(props.tab3.redirectTo);
        }}
      />
    </Tabs>
  );
};
